module.exports = __webpack_public_path__ + "img/15-1.149c5890.png";